var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.extras.groupIntroductionDisplay.display == 1)?_c('div',{staticClass:"pc-assembly top-nav new",style:({
    background:
      _vm.extras.introBg.colorOrBg == 'color'
        ? _vm.extras.introBg.color
        : 'url(' + _vm.extras.introBg.src + ')',
  }),attrs:{"id":"introduction"}},[_c('div',{staticClass:"max"},[(_vm.extras && _vm.extras.IntroTitle.display == 1)?_c('Title',{attrs:{"title":_vm.extras.IntroTitle.mainTitle || _vm.title,"en":_vm.extras.IntroTitle.subTitle || 'Introduction',"extras":_vm.extras}}):_vm._e(),(_vm.seminarInfo.desc.length == 0)?_c('div',{staticClass:"m-nodata-body"},[_c('img',{attrs:{"src":require("@/assets/images/nodata.png")}}),_c('div',{staticClass:"m-nodata"},[_vm._v(_vm._s(_vm.$t("暂无数据")))])]):_vm._e(),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(
        _vm.$i18nField(
          _vm.seminarInfo.i18n && _vm.seminarInfo.i18n.seminar,
          'desc',
          _vm.seminarInfo.desc
        )
      )}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }